import { render, staticRenderFns } from "./ComplianceExpiredElements.vue?vue&type=template&id=1008996e&"
import script from "./ComplianceExpiredElements.vue?vue&type=script&lang=ts&"
export * from "./ComplianceExpiredElements.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports